import React from "react";

function CheckboxOption({ formData, setFormData, title, options, col = 1 }) {
  // options: array semplice di opzioni
  const values = formData.otherServices
    ? formData.otherServices.split("/;/")
    : [];

  const handleChange = (opt) => {
    let newValues = [...values];
    if (newValues.includes(opt)) {
      newValues = newValues.filter((v) => v !== opt);
    } else {
      newValues.push(opt);
    }
    setFormData({
      ...formData,
      otherServices: newValues.join("/;/"),
    });
  };

  return (
    <>
      <label>{title}</label>
      <div className="row">
        {options.map((opt) => (
          <div className={`form-check col-` + 12 / col} key={opt}>
            <input
              className="form-check-input"
              type="checkbox"
              id={opt}
              checked={values.includes(opt)}
              onChange={() => handleChange(opt)}
            />
            <label className="form-check-label" htmlFor={opt}>
              {opt}
            </label>
          </div>
        ))}
      </div>
    </>
  );
}

export default CheckboxOption;
